import { Component, inject } from '@angular/core';
import { SharedModule } from '@app/shared/shared.module';
import { Router } from '@angular/router';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { CourseListingTableDetailsComponent } from '../course-listing-table-details/course-listing-table-details.component';
import { Utilities } from '@app/core/utils/utilities';
import { CourseInstanceListingPageComponent } from '../course-instance-listing-page/course-instance-listing-page.component';

@Component({
  selector: 'app-course-listing-page',
  imports: [SharedModule, CourseListingTableDetailsComponent],
  templateUrl: './course-listing-page.component.html',
  styleUrl: './course-listing-page.component.css'
})
export class CourseListingPageComponent {
  router = inject(Router);
  util = inject(Utilities);
  dialog = inject(MatDialog);
  courseDialogData: any;
  dialogRef: any;

  constructor() {
    if (!this.router.url.includes('/manage-course') || this.router.url.includes('/instance')) {
      this.dialogRef = inject(MatDialogRef<CourseListingPageComponent>);
      this.courseDialogData = inject(MAT_DIALOG_DATA);
    }
  }

  closeCourseListingPopup(courseData: any) {
    if (courseData) {
      this.dialogRef.close();
      this.util.isDialogOpen$.set(true);
      this.util.assignedCourseInstancePopup.set(true);
      const dialogRef = this.dialog.open(CourseInstanceListingPageComponent, {
        data: { ...courseData, courseTypeId: courseData.courseTypeId, erDialogData: courseData.erDialogData, pageType: 'assignedErInstances' },
        width: '1114px',
        panelClass: 'view-er-instance-list-popup'
      });
      dialogRef.afterClosed().subscribe((result: any) => {
        this.util.isDialogOpen$.set(false);
        this.util.assignedCourseInstancePopup.set(false);
      })
    }
  }
}
